import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {c as esm, o as objectWithoutPropertiesLoose, _ as _extends_1, e as esm$1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {c as createSvgIcon_1} from "./createSvgIcon-ee034812.js";
import _jsxRuntime from "react/jsx-runtime";
import {u as useForkRef} from "./useForkRef-b591be37.js";
import {c as capitalize} from "./capitalize-0607751a.js";
import {B as ButtonBase} from "./index-ef2a811c.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
var Cancel = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
  }), "Cancel");
  exports.default = _default;
});
var unsupportedProp = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = esm.unstable_unsupportedProp;
  exports.default = _default;
});
var chipClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getChipUtilityClass = getChipUtilityClass;
  function getChipUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiChip", slot);
  }
  const chipClasses = (0, core.generateUtilityClasses)("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorPrimary", "colorSecondary", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "focusVisible"]);
  var _default = chipClasses;
  exports.default = _default;
});
var Chip_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _Cancel = interopRequireDefault(Cancel);
  var _useForkRef = interopRequireDefault(useForkRef);
  var _unsupportedProp = interopRequireDefault(unsupportedProp);
  var _capitalize = interopRequireDefault(capitalize);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  var _chipClasses = _interopRequireWildcard(chipClasses_1);
  const _excluded = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      disabled,
      size,
      color,
      onDelete,
      clickable,
      variant
    } = ownerState;
    const slots = {
      root: ["root", variant, disabled && "disabled", `size${(0, _capitalize.default)(size)}`, `color${(0, _capitalize.default)(color)}`, clickable && "clickable", clickable && `clickableColor${(0, _capitalize.default)(color)}`, onDelete && "deletable", onDelete && `deletableColor${(0, _capitalize.default)(color)}`, `${variant}${(0, _capitalize.default)(color)}`],
      label: ["label", `label${(0, _capitalize.default)(size)}`],
      avatar: ["avatar", `avatar${(0, _capitalize.default)(size)}`, `avatarColor${(0, _capitalize.default)(color)}`],
      icon: ["icon", `icon${(0, _capitalize.default)(size)}`, `iconColor${(0, _capitalize.default)(color)}`],
      deleteIcon: ["deleteIcon", `deleteIcon${(0, _capitalize.default)(size)}`, `deleteIconColor${(0, _capitalize.default)(color)}`, `deleteIconOutlinedColor${(0, _capitalize.default)(color)}`]
    };
    return (0, core.unstable_composeClasses)(slots, _chipClasses.getChipUtilityClass, classes);
  };
  const ChipRoot = (0, _styled.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      const {
        color,
        clickable,
        onDelete,
        size,
        variant
      } = ownerState;
      return [{
        [`& .${_chipClasses.default.avatar}`]: styles.avatar
      }, {
        [`& .${_chipClasses.default.avatar}`]: styles[`avatar${(0, _capitalize.default)(size)}`]
      }, {
        [`& .${_chipClasses.default.avatar}`]: styles[`avatarColor${(0, _capitalize.default)(color)}`]
      }, {
        [`& .${_chipClasses.default.icon}`]: styles.icon
      }, {
        [`& .${_chipClasses.default.icon}`]: styles[`icon${(0, _capitalize.default)(size)}`]
      }, {
        [`& .${_chipClasses.default.icon}`]: styles[`iconColor${(0, _capitalize.default)(color)}`]
      }, {
        [`& .${_chipClasses.default.deleteIcon}`]: styles.deleteIcon
      }, {
        [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize.default)(size)}`]
      }, {
        [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, _capitalize.default)(color)}`]
      }, {
        [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIconOutlinedColor${(0, _capitalize.default)(color)}`]
      }, styles.root, styles[`size${(0, _capitalize.default)(size)}`], styles[`color${(0, _capitalize.default)(color)}`], clickable && styles.clickable, clickable && color !== "default" && styles[`clickableColor${(0, _capitalize.default)(color)})`], onDelete && styles.deletable, onDelete && color !== "default" && styles[`deletableColor${(0, _capitalize.default)(color)}`], styles[variant], variant === "outlined" && styles[`outlined${(0, _capitalize.default)(color)}`]];
    }
  })(({
    theme,
    ownerState
  }) => {
    const deleteIconColor = (0, esm$1.alpha)(theme.palette.text.primary, 0.26);
    return (0, _extends2.default)({
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: 32,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.selected,
      borderRadius: 32 / 2,
      whiteSpace: "nowrap",
      transition: theme.transitions.create(["background-color", "box-shadow"]),
      cursor: "default",
      outline: 0,
      textDecoration: "none",
      border: 0,
      padding: 0,
      verticalAlign: "middle",
      boxSizing: "border-box",
      [`&.${_chipClasses.default.disabled}`]: {
        opacity: theme.palette.action.disabledOpacity,
        pointerEvents: "none"
      },
      [`& .${_chipClasses.default.avatar}`]: {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      [`& .${_chipClasses.default.avatarColorPrimary}`]: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      [`& .${_chipClasses.default.avatarColorSecondary}`]: {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      [`& .${_chipClasses.default.avatarSmall}`]: {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      },
      [`& .${_chipClasses.default.icon}`]: (0, _extends2.default)({
        color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
        marginLeft: 5,
        marginRight: -6
      }, ownerState.size === "small" && {
        fontSize: 18,
        marginLeft: 4,
        marginRight: -4
      }, ownerState.color !== "default" && {
        color: "inherit"
      }),
      [`& .${_chipClasses.default.deleteIcon}`]: (0, _extends2.default)({
        WebkitTapHighlightColor: "transparent",
        color: deleteIconColor,
        fontSize: 22,
        cursor: "pointer",
        margin: "0 5px 0 -6px",
        "&:hover": {
          color: (0, esm$1.alpha)(deleteIconColor, 0.4)
        }
      }, ownerState.size === "small" && {
        fontSize: 16,
        marginRight: 4,
        marginLeft: -4
      }, ownerState.color !== "default" && {
        color: (0, esm$1.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
        "&:hover, &:active": {
          color: theme.palette[ownerState.color].contrastText
        }
      })
    }, ownerState.size === "small" && {
      height: 24
    }, ownerState.color !== "default" && {
      backgroundColor: theme.palette[ownerState.color].main,
      color: theme.palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
      [`&.${_chipClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm$1.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    }, ownerState.onDelete && ownerState.color !== "default" && {
      [`&.${_chipClasses.default.focusVisible}`]: {
        backgroundColor: theme.palette[ownerState.color].dark
      }
    });
  }, ({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, ownerState.clickable && {
    userSelect: "none",
    WebkitTapHighlightColor: "transparent",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: (0, esm$1.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    },
    [`&.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: (0, esm$1.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    },
    "&:active": {
      boxShadow: theme.shadows[1]
    }
  }, ownerState.clickable && ownerState.color !== "default" && {
    [`&:hover, &.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette[ownerState.color].dark
    }
  }), ({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, ownerState.variant === "outlined" && {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
    [`&.${_chipClasses.default.clickable}:hover`]: {
      backgroundColor: theme.palette.action.hover
    },
    [`&.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`& .${_chipClasses.default.avatar}`]: {
      marginLeft: 4
    },
    [`& .${_chipClasses.default.avatarSmall}`]: {
      marginLeft: 2
    },
    [`& .${_chipClasses.default.icon}`]: {
      marginLeft: 4
    },
    [`& .${_chipClasses.default.iconSmall}`]: {
      marginLeft: 2
    },
    [`& .${_chipClasses.default.deleteIcon}`]: {
      marginRight: 5
    },
    [`& .${_chipClasses.default.deleteIconSmall}`]: {
      marginRight: 3
    }
  }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
    color: theme.palette[ownerState.color].main,
    border: `1px solid ${(0, esm$1.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
    [`&.${_chipClasses.default.clickable}:hover`]: {
      backgroundColor: (0, esm$1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
    },
    [`&.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: (0, esm$1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
    },
    [`& .${_chipClasses.default.deleteIcon}`]: {
      color: (0, esm$1.alpha)(theme.palette[ownerState.color].main, 0.7),
      "&:hover, &:active": {
        color: theme.palette[ownerState.color].main
      }
    }
  }));
  const ChipLabel = (0, _styled.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      const {
        size
      } = ownerState;
      return [styles.label, styles[`label${(0, _capitalize.default)(size)}`]];
    }
  })(({
    ownerState
  }) => (0, _extends2.default)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: "nowrap"
  }, ownerState.size === "small" && {
    paddingLeft: 8,
    paddingRight: 8
  }));
  function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
  }
  const Chip2 = /* @__PURE__ */ React$1.forwardRef(function Chip3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiChip"
    });
    const {
      avatar: avatarProp,
      className,
      clickable: clickableProp,
      color = "default",
      component: ComponentProp,
      deleteIcon: deleteIconProp,
      disabled = false,
      icon: iconProp,
      label,
      onClick,
      onDelete,
      onKeyDown,
      onKeyUp,
      size = "medium",
      variant = "filled"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const chipRef = React$1.useRef(null);
    const handleRef = (0, _useForkRef.default)(chipRef, ref);
    const handleDeleteIconClick = (event) => {
      event.stopPropagation();
      if (onDelete) {
        onDelete(event);
      }
    };
    const handleKeyDown = (event) => {
      if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
        event.preventDefault();
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    };
    const handleKeyUp = (event) => {
      if (event.currentTarget === event.target) {
        if (onDelete && isDeleteKeyboardEvent(event)) {
          onDelete(event);
        } else if (event.key === "Escape" && chipRef.current) {
          chipRef.current.blur();
        }
      }
      if (onKeyUp) {
        onKeyUp(event);
      }
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const small = size === "small";
    const component = clickable || onDelete ? _ButtonBase.default : ComponentProp || "div";
    const ownerState = (0, _extends2.default)({}, props, {
      component,
      disabled,
      size,
      color,
      onDelete: !!onDelete,
      clickable,
      variant
    });
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === _ButtonBase.default ? (0, _extends2.default)({
      component: ComponentProp || "div",
      focusVisibleClassName: classes.focusVisible
    }, onDelete && {
      disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) {
      const customClasses = (0, _clsx.default)(color !== "default" && (variant === "outlined" ? classes[`deleteIconOutlinedColor${(0, _capitalize.default)(color)}`] : classes[`deleteIconColor${(0, _capitalize.default)(color)}`]), small && classes.deleteIconSmall);
      deleteIcon = deleteIconProp && /* @__PURE__ */ React$1.isValidElement(deleteIconProp) ? /* @__PURE__ */ React$1.cloneElement(deleteIconProp, {
        className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
        onClick: handleDeleteIconClick
      }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Cancel.default, {
        className: (0, _clsx.default)(classes.deleteIcon, customClasses),
        onClick: handleDeleteIconClick
      });
    }
    let avatar = null;
    if (avatarProp && /* @__PURE__ */ React$1.isValidElement(avatarProp)) {
      avatar = /* @__PURE__ */ React$1.cloneElement(avatarProp, {
        className: (0, _clsx.default)(classes.avatar, avatarProp.props.className)
      });
    }
    let icon = null;
    if (iconProp && /* @__PURE__ */ React$1.isValidElement(iconProp)) {
      icon = /* @__PURE__ */ React$1.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
      });
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(ChipRoot, (0, _extends2.default)({
      as: component,
      className: (0, _clsx.default)(classes.root, className),
      disabled: clickable && disabled ? true : void 0,
      onClick,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      ref: handleRef,
      ownerState
    }, moreProps, other, {
      children: [avatar || icon, /* @__PURE__ */ (0, _jsxRuntime.jsx)(ChipLabel, {
        className: (0, _clsx.default)(classes.label),
        ownerState,
        children: label
      }), deleteIcon]
    }));
  });
  var _default = Chip2;
  exports.default = _default;
});
var Chip = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    chipClasses: true
  };
  Object.defineProperty(exports, "chipClasses", {
    enumerable: true,
    get: function() {
      return _chipClasses.default;
    }
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Chip.default;
    }
  });
  var _Chip = interopRequireDefault(Chip_1);
  var _chipClasses = _interopRequireWildcard(chipClasses_1);
  Object.keys(_chipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _chipClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _chipClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Chip);
export {Chip as C, __pika_web_default_export_for_treeshaking__ as _};
